import CustomText from "../atomic/CustomText";

function TestTypeCell({
  cell,
  row,
}: {
  cell: any;
  row: any;
}): JSX.Element | null {
  const testType: any = row?.original?.testTypes ?? null;

  if (cell.column.getIsVisible() === false) {
    return null;
  }

  const displayText = testType?.name?.split(":")[0] ?? "N/A";

  return (
    <div className="flex items-center min-w-[140px]">
      <CustomText text={displayText} fontWeight="font-normal" />
    </div>
  );
}

export default TestTypeCell;
